module.exports = __webpack_public_path__ + "1504fb12b6ef1d2ba75702f4dc2d86a5.pdf";